angular.module("vgresiduos").directive("destinationTemporaryStorageArrival", function () {
	return {
		scope: true,
		controller: "DestinationTemporaryStorageArrivalCtrl",
		controllerAs: "ctrl",
		templateUrl:
			"views/destination/stages/destinationTemporaryStorageArrival/destinationTemporaryStorageArrival_template.html"
	};
});
